export { default } from './Settings';
export { default as SettingsIcon } from './Icon.svg';